import { parseColors } from '../etColors';

/** Text with ET colour codes rendered as colours. */
export function ColorText({ text, class: cls }: { text: string; class?: string }) {
  return (
    <span class={cls}>
      {parseColors(text).map((s, i) => (
        <span key={i} style={s.color ? { color: s.color } : undefined}>
          {s.text}
        </span>
      ))}
    </span>
  );
}
